import type { PayoutInstrument } from './types';

/**
 * Upper-cases and drops separators so `BANK_TRANSFER`, `bank-transfer` and `BANKTRANSFER` all compare equal.
 */
function normaliseInstrumentType(value?: string): string {
  return (value ?? '').toUpperCase().replace(/[^A-Z0-9]/g, '');
}

/**
 * Narrows the cashier's payout instruments to the types the market offers.
 *
 * `allowedTypes` unset means the market places no restriction and every instrument is returned untouched.
 */
function filterAllowedPayoutInstruments(instruments: readonly PayoutInstrument[], allowedTypes?: readonly string[]): readonly PayoutInstrument[] {
  if (!allowedTypes) {
    return instruments;
  }

  const allowed = allowedTypes.map(normaliseInstrumentType);

  return instruments.filter(instrument => {
    const instrumentType = normaliseInstrumentType(instrument.paymentMethodType);
    return instrumentType !== '' && allowed.includes(instrumentType);
  });
}

export { filterAllowedPayoutInstruments, normaliseInstrumentType };
